import Vue from 'vue'

const serverTime = Vue.observable({
  localTimeAtFetch: 0,
  serverTimeDateObj: null,
})

export const serverTimeFunc = {
  async fetchServerTime() {
    try {
      const { result } = await Vue.prototype.$Fetcher.GetServerTime()
      serverTime.serverTimeDateObj = Vue.prototype.$formatter.getDateObj(result)
      serverTime.localTimeAtFetch = Date.now()
    } catch (err) {
      Vue.prototype.$common.error(err)
    }
  },

  getServerCurrentTime() {
    if (serverTime.serverTimeDateObj === null) {
      return Vue.prototype.$formatter.formatDate(new Date(), true)
    }

    // Calculate elapsed time since server time was fetched
    const elapsedMs = Date.now() - serverTime.localTimeAtFetch

    // Return server time + elapsed time
    const currentServerTime = new Date(serverTime.serverTimeDateObj.getTime() + elapsedMs)
    return Vue.prototype.$formatter.formatDate(currentServerTime, true)
  },

  getLocalCurrentDateObj() {
    const currentTime = this.getServerCurrentTime()
    return Vue.prototype.$formatter.getDateObj(currentTime)
  },
}
